import { render, staticRenderFns } from "./ContactFollowUp.vue?vue&type=template&id=31336bb8&scoped=true&"
import script from "./ContactFollowUp.vue?vue&type=script&lang=js&"
export * from "./ContactFollowUp.vue?vue&type=script&lang=js&"
import style0 from "./ContactFollowUp.vue?vue&type=style&index=0&id=31336bb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31336bb8",
  null
  
)

export default component.exports